import { Component } from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-portage-presentation',
  standalone: true,
    imports: [
        NgOptimizedImage
    ],
  templateUrl: './portage-presentation.component.html',
  styleUrl: './portage-presentation.component.css'
})
export class PortagePresentationComponent {

}
